module.exports = __webpack_public_path__ + "resource/img/delete.10f4c229.svg";